import api from './api';

export const bulkService = {
  assign: (data) => api.post('/tickets/bulk/assign', data),
  updateStatus: (data) => api.post('/tickets/bulk/status', data),
  close: (data) => api.post('/tickets/bulk/close', data),
};
